module.exports = __webpack_public_path__ + "img/48.f9dc1f86.jpg";